import { type ContactAppId, SEROPHIN_OPERATOR, SEROPHIN_OPERATOR_DETAILS, SUPPORT_EMAIL, serophinContactUrl } from "./contact";
import { legalEmailLink, legalLink } from "./inline";
import type { LegalText } from "./types";

export type LegalApp = {
  id: ContactAppId;
  product: string;
  site: string;
  operator: string;
  operatorDetails?: string;
  effectiveDate: string;
  contactEmail: string;
  contactUrl: string;
};

export type LegalAppInput = Pick<LegalApp, "id" | "product" | "site" | "effectiveDate" | "operatorDetails">;

export const legalApp = (input: LegalAppInput): LegalApp => ({
  operator: SEROPHIN_OPERATOR,
  operatorDetails: SEROPHIN_OPERATOR_DETAILS,
  contactEmail: SUPPORT_EMAIL,
  contactUrl: serophinContactUrl(input.id),
  ...input,
});

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const formatLegalDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-").map(Number);
  const name = MONTHS[(month ?? 0) - 1];
  if (!(year && name && day)) {
    throw new Error(`Not an ISO date: ${isoDate}`);
  }
  return `${day} ${name} ${year}`;
};

export const operatorWithDetails = (app: LegalApp): string => (app.operatorDetails ? `${app.operator}, ${app.operatorDetails}` : app.operator);

export const contactEmailLink = (app: LegalApp): LegalText => legalEmailLink(app.contactEmail);

export const contactPageLink = (app: LegalApp, label = "contact page"): LegalText => legalLink(label, app.contactUrl);

export const contactLinks = (app: LegalApp): LegalText => `${contactEmailLink(app)} or through our ${contactPageLink(app)}`;
